"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQRCodeSVG = exports.toQrCodeSvg = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var web_log_1 = require("@snapchat/web-log");
var qrcodegen_1 = require("./qrcodegen");
var react_1 = require("react");
var toSvg = function (qr, border, fillColor, backgroundColor, svgTitle, qrWidth, qrHeight) {
    var parts = [];
    for (var y = 0; y < qr.size; y++) {
        for (var x = 0; x < qr.size; x++) {
            if (qr.getModule(x, y))
                parts.push("M".concat(x + border, ",").concat(y + border, "h1v1h-1z"));
        }
    }
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 ".concat(qr.size + border * 2, " ").concat(qr.size + border * 2), stroke: "none", height: qrHeight, width: qrWidth }, { children: [(0, jsx_runtime_1.jsx)("title", { children: svgTitle }), (0, jsx_runtime_1.jsx)("rect", { width: "100%", height: "100%", fill: fillColor }), (0, jsx_runtime_1.jsx)("path", { d: parts.join(" "), fill: backgroundColor })] })));
};
/**
 * Convert strings to QR code in SVG
 */
var toQrCodeSvg = function (text, fillColor, backgroundColor, errorCorrection, svgTitle, border, width, height) {
    if (border === void 0) { border = 0; }
    if (width === void 0) { width = 250; }
    if (height === void 0) { height = 250; }
    try {
        var qrCode = qrcodegen_1.QrCode.encodeText(text, errorCorrection);
        return toSvg(qrCode, border, fillColor, backgroundColor, svgTitle, width, height);
    }
    catch (e) {
        web_log_1.log.error("Error occured while generating QR code for text ".concat(text), e);
    }
};
exports.toQrCodeSvg = toQrCodeSvg;
/**
 * [Hook] Generate QR code SVG based on params
 */
var useQRCodeSVG = function (props) {
    var _a = (0, react_1.useState)(undefined), QRCodeSVG = _a[0], setQRCodeSVG = _a[1];
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        var qrCodeSVG = (0, exports.toQrCodeSvg)(props.text, props.fillColor, props.backgroundColor, props.errorCorrection, props.svgTitle, (_a = props.border) !== null && _a !== void 0 ? _a : 0, (_b = props.width) !== null && _b !== void 0 ? _b : 250, (_c = props.height) !== null && _c !== void 0 ? _c : 250);
        setQRCodeSVG(qrCodeSVG);
    }, [
        props.backgroundColor,
        props.border,
        props.errorCorrection,
        props.fillColor,
        props.height,
        props.svgTitle,
        props.text,
        props.width,
    ]);
    return QRCodeSVG;
};
exports.useQRCodeSVG = useQRCodeSVG;
//# sourceMappingURL=qr-code-generator.js.map